.badge {
  display: inline-block;
  padding: 0.25em 0.4em;
  font-size: 0.8em;
  font-weight: bold;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.3rem;
  border: 2px solid rgba(50,50,50,0.25);
  
  //color: rgba(0, 0, 0, 0.54);
}

.badgeText {
  color: rgba(0, 0, 0, 0.54);
}

.skeleton {
  display: inline-block!important;
  border-radius: 0.3rem!important;
}

.new {
  background-color: #ffd146;
}